// THIS FILE WAS GENERATED BY A SCRIPT AND SHOULD NOT BE UPDATED MANUALLY

export * from "@react-md/core/test-utils/vitest/setup";
